import O1HD from "../../../engines/gameEngine";

const {ccclass, property} = cc._decorator;

@ccclass
export default class attentionPage extends cc.Component {

    onceKey:string = "attention-once-coin-key";

    onBtnClose(){
        this.node.destroy();
    }

    onBtnComit(){
        O1HD.getManagers().soundMgr.playSound('anNiu').then();
        if(window['tt'])
        {
             window['tt'].openAwemeUserProfile({
                success:(res)=>{
                    if(res.hasFollowed){
                        if(O1HD.getServices().localStorageSrv.getStorage(this.onceKey) != "1"){
                            O1HD.getServices().userSrv.setCoins(1000000,true,this.node);
                            O1HD.getServices().localStorageSrv.setStorage(this.onceKey,1);
                        }
                    }
                },
                fail:()=>{

                },
                complete:()=>{

                }
             });
        }
    }

}
